export const PERMS = {
    READ: 'trailer_equipments.read',
    UPDATE: 'trailer_equipments.update',
    DELETE: 'trailer_equipments.delete',
    CREATE: 'trailer_equipments.create',
    EXPORT: 'trailer_equipments.export',
}
